// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"List__Wrapper_-spEu","Tab":"List__Tab_1-TOf","Items":"List__Items_2r1xr grid"};